<script>
import addDays from 'date-fns/addDays';
import DatePicker from 'vue-datepicker-next';
import { ptBrDatePickerLang } from 'shared/helpers/datePickerLocales';

export default {
  components: { DatePicker },
  props: {
    confirmText: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: Date,
      default: [],
    },
    format: {
      type: String,
      default: 'DD-MM-YYYY HH:mm:ss',
    },
    showSecond: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['change'],

  data() {
    return {
      lang: ptBrDatePickerLang,
    };
  },

  methods: {
    handleChange(value) {
      this.$emit('change', value);
    },
    disableBeforeToday(date) {
      const yesterdayDate = addDays(new Date(), -1);
      return date < yesterdayDate;
    },
  },
};
</script>

<template>
  <div class="date-picker">
    <DatePicker
      type="datetime"
      :format="format"
      confirm
      :show-second="showSecond"
      :clearable="false"
      :editable="false"
      :confirm-text="confirmText"
      :placeholder="placeholder"
      :value="value"
      :disabled-date="disableBeforeToday"
      :lang="lang"
      @change="handleChange"
    />
  </div>
</template>
